module.exports = __webpack_public_path__ + "static/1-51f562f1f5a539ba1f836e0e7985557a.svg";